import { createSlice } from "@reduxjs/toolkit";

interface schematicState {
   jetPumpSize : any;
};

export const initialState: schematicState = {
    jetPumpSize: [],
};

const SchematicSlice = createSlice({
    name: "schematic",
    initialState,
    reducers: {
        setJetPumpSize: (state, action) => {
            state.jetPumpSize = action?.payload;
        },
    },
});

export const {
    setJetPumpSize
} = SchematicSlice.actions;

export default SchematicSlice.reducer;